import { Directive, EventEmitter, HostListener, Input, Output } from '@angular/core';

// Minimal no-op directives to satisfy Angular templates that use MDC icon button and ripple attributes.
// These do not provide MDC behavior; they only prevent template compilation errors and support simple two-way binding.

@Directive({
    selector: '[mdcIconButton]'
})
export class MdcIconButtonDirective {
  @Input() iconOn?: string;
  @Input() iconOff?: string;
  @Input() dense?: boolean | string;
  @Input() disabled?: boolean | string;

  // Support banana-in-a-box [(on)] binding
  @Input() on?: boolean;
  @Output() onChange = new EventEmitter<boolean>();

  @HostListener('click', ['$event'])
  handleClick(event: Event) {
    // If two-way bound, toggle and emit to keep templates functional in a basic way
    if (this.on !== undefined && this.disabled !== true && this.disabled !== 'true') {
      this.on = !this.on;
      this.onChange.emit(this.on);
    }
  }
}

@Directive({
  
  selector: '[mdcRipple]'
})
export class MdcRippleDirective {
  // Allows [mdcRipple]="false" and mdcRipple="false"
  @Input('mdcRipple') mdcRipple?: boolean | string;
}
